import styles from './TypingIndicator.module.css';

interface TypingIndicatorProps {
  label?: string;
}

export function TypingIndicator({ label = 'AI is thinking…' }: TypingIndicatorProps) {
  return (
    <div className={styles.wrapper} aria-label={label} role="status">
      <div className={styles.dots}>
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </div>
      <span className={styles.label}>{label}</span>
    </div>
  );
}
